import React from 'react';
const comparisonRows = [{
  situation: 'Tu cobro',
  without: 'Por sesión, irregular',
  with: 'Abono mensual el día 1-5'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos desde el día 5'
}, {
  situation: 'Nuevos pacientes',
  without: 'Solo boca a boca',
  with: 'Sistema de admisión activo'
}, {
  situation: 'Informes',
  without: 'Sin plantilla, horas de trabajo',
  with: 'Reporte en 1 página en 5 min'
}, {
  situation: 'Tu Instagram',
  without: 'Sin estrategia',
  with: '30 días de contenido listo'
}, {
  situation: 'El paciente que abandona',
  without: 'Sin sistema',
  with: 'Protocolo de re-enganche'
}, {
  situation: 'Tus honorarios',
  without: 'Los del mercado o menos',
  with: '30-50% más justificados'
}];
const blocks = [{
  num: '01',
  emoji: '💰',
  title: 'El Abono Blindado',
  desc: 'Cobro mensual adelantado + reglamento + contrato listo para usar.'
}, {
  num: '02',
  emoji: '📋',
  title: 'Informes Rápidos',
  desc: 'Frases clínicas copy/paste. Reporte en 1 página en 5 minutos.'
}, {
  num: '03',
  emoji: '📱',
  title: 'WhatsApp que Retiene',
  desc: 'Scripts de conversión + seguimiento semanal automático.'
}, {
  num: '04',
  emoji: '📸',
  title: 'Autoridad Digital',
  desc: '20 tipos de post + calendario de 30 días listo para publicar.'
}];
const assets = ['Planilla de Pagos', 'Calculadora de Honorarios', 'Reglamento', 'Contrato', 'Consentimiento', 'Autorización de Imagen', '20 Stories'];
export function ProBusiness() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-231">
      <div className="mx-auto max-w-3xl" data-id="element-232">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-233">
          ¿Qué agrega{' '}
          <span className="text-violet-700" data-id="element-234">Autoridad Clínica™?</span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-235">
          El sistema de cobro, gestión e identidad profesional que hace que tu
          práctica esté a la altura de tu formación.
        </p>

        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-236">
          <span data-id="element-237">👆</span> Deslizá para ver la tabla completa
        </p>

        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(109, 40, 217, 0.2)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-238">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-239">
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-240">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-241">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-242">
                ❌ Sin Autoridad Clínica
              </div>
              <div className="px-4 py-3 text-xs font-bold text-violet-700 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-243">
                ✅ Con Autoridad Clínica
              </div>
            </div>

            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-244">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-245">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-246">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgb(245, 243, 255)'
            }} data-id="element-247">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-248">
          <div className="bg-violet-700 px-5 py-3" data-id="element-249">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-250">
              🏆 AUTORIDAD CLÍNICA™ INCLUYE:
            </h3>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-251">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-252">
                <span className="shrink-0 text-lg font-black text-violet-700/30 w-8 text-center" data-id="element-253">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-254">
                  <span className="block text-sm font-black text-gray-900" data-id="element-255">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-256">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(245, 243, 255)',
        border: '1px solid rgba(109, 40, 217, 0.2)'
      }} data-id="element-257">
          <p className="text-xs font-bold text-violet-700 uppercase tracking-widest m-0 mb-3" data-id="element-258">
            📊 Assets incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-259">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold text-violet-700 bg-white border border-violet-500/20 rounded-full px-3 py-1" data-id="element-260">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}